import { render } from "./CheckPayment.vue?vue&type=template&id=32e93d10&scoped=true&ts=true"
import script from "./CheckPayment.vue?vue&type=script&lang=ts"
export * from "./CheckPayment.vue?vue&type=script&lang=ts"

import "./CheckPayment.vue?vue&type=style&index=0&id=32e93d10&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e93d10"]])

export default __exports__